<template>
    <div class="swiper">
        <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="gravure_item in gravure_list">
                <a :href=gravure_item.url>
                    <div class="c-slider-normal__img">
                        <webp-picture :webp="gravure_item.thumbnail_webp" class="inherit">
                            <img :src="gravure_item.thumbnail" :alt="gravure_item.title" loading="lazy">
                        </webp-picture>
                    </div>
                    <div class="sale">{{gravure_item.discount_rate}}% OFF</div>
                    <div class="label-container">
                        <div class="c-label-new" v-if="gravure_item.is_new">New</div>
                        <div class="c-label-photobook">{{ gravure_item.category_label }}</div>
                        <div class="c-label-limited" v-if="gravure_item.extra">限定特典付</div>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-booktitle u-text-ellipsis has-2-lines">{{ gravure_item.title }}</p>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-bookname u-text-ellipsis has-2-lines">{{ gravure_item.model_name }}</p>
                    </div>
                </a>
                <div v-if="gravure_item.BROWSER_VIEW_PARAM" class="c-btn-trial">
                    <a :href="route(route_list, 'site.item.sample', {item_detail_url: gravure_item.item_detail_url})" target="_blank">立ち読み</a>
                </div>
            </div>
        </div>
        <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
  props:[
      'gravure_list',
      'route_list',
      'utm_content'
  ],
  mixins: [routeMixin],
}
</script>

<style scoped>
.swiper {
  width: 100%;
}

.sale {
    font-size: 10px;
    line-height: 13px;
    color: var(--gj-text-color-invert);
    background-color: #FD0061;
    border-radius: 2px;
    width: 100%;
    min-height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2px;
}

.label-container {
    min-height: 42px;
    display: flex;
    flex-wrap: wrap;
}

.c-booktitle {
    margin: 0;
    color: var(--gj-text-color-light);
    text-align: start;
    word-break: break-all;
}

.c-bookname {
    margin: 0;
    text-align: start;
    align-items: center;
    line-height: 18.2px;
}

.c-book-block__wrapper {
    display: flex;
    align-items: center;
    &:has(.c-booktitle) {
        min-height: 32px;
    }
    &:has(.c-bookname) {
        min-height: 37px;
        margin-bottom: 8px;
    }
}
</style>
